import { Static, Type } from "@sinclair/typebox";

export const OrgPartner = Type.Union([Type.Literal("None"), Type.Literal("Dfense"), Type.Literal("TDec")]);
export type OrgPartnerType = Static<typeof OrgPartner>;

export const orgPartnerValues: OrgPartnerType[] = OrgPartner.anyOf.map((literal) => literal.const);
